"use client";

import { c as _c } from "react/compiler-runtime";
import { NinetailedProvider as NinetailedSdkProvider } from "@ninetailed/experience.js-react";
import dynamic from "next/dynamic";
import type { ReactNode } from "react";
import type { PreviewData } from "@/lib/ninetailed/getPreviewData";
import { NinetailedPageTracker } from "./NinetailedPageTracker";
import { insightsPlugin } from "./ninetailedInsightsPlugin";
import { ssrPlugin } from "./ninetailedSsrPlugin";

// Loaded on demand so the preview plugin only ships to draft-mode visitors.
const NinetailedPreviewProvider = dynamic(() => import("./NinetailedPreviewProvider").then(mod => mod.NinetailedPreviewProvider));
interface Props {
  apiKey: string;
  environment: string;
  spaceId?: string;
  contentfulEnvironment?: string;
  preview?: PreviewData;
  children: ReactNode;
}
export function NinetailedProvider(t0) {
  const $ = _c(13);
  const {
    apiKey,
    environment,
    spaceId,
    contentfulEnvironment,
    preview,
    children
  } = t0;
  if (preview) {
    let t1;
    if ($[0] !== apiKey || $[1] !== children || $[2] !== contentfulEnvironment || $[3] !== environment || $[4] !== preview || $[5] !== spaceId) {
      t1 = <NinetailedPreviewProvider apiKey={apiKey} environment={environment} spaceId={spaceId} contentfulEnvironment={contentfulEnvironment} preview={preview}>{children}</NinetailedPreviewProvider>;
      $[0] = apiKey;
      $[1] = children;
      $[2] = contentfulEnvironment;
      $[3] = environment;
      $[4] = preview;
      $[5] = spaceId;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [ssrPlugin, insightsPlugin];
    t2 = <NinetailedPageTracker />;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  let t3;
  if ($[9] !== apiKey || $[10] !== children || $[11] !== environment) {
    t3 = <NinetailedSdkProvider clientId={apiKey} environment={environment} plugins={t1}>{t2}{children}</NinetailedSdkProvider>;
    $[9] = apiKey;
    $[10] = children;
    $[11] = environment;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}